module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/en.2205966b.webp";